import SubscriptionSelectionStarterKit from './SubscriptionSelectionStarterKit';

export default SubscriptionSelectionStarterKit;
